import styled from 'styled-components';
import { useBusinessHoursProps } from '../business-hours-props-context';
import { RenderRegularDays } from './render-regular-days';
import { RenderSpecialDays } from './render-special-days';
import { ScheduleProvider } from './schedule-context';

export type ScheduleProps = {
  insidePopout?: boolean;
};

export function Schedule({ insidePopout }: ScheduleProps) {
  const { alignment } = useBusinessHoursProps();

  return (
    <ScheduleProvider insidePopout={insidePopout}>
      <Container _alignment={alignment}>
        <RenderRegularDays />
        <RenderSpecialDays />
      </Container>
    </ScheduleProvider>
  );
}

const Container = styled.div<{ _alignment: 'left' | 'center' | 'right' }>`
  display: inline-flex;
  flex-direction: column;
  align-items: ${({ _alignment }) =>
    ({ left: 'start', center: 'center', right: 'end' })[_alignment]};
  gap: 32px;
  width: 100%;
`;
